import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";

import { DatePickerModel } from "src/app/components/date-picker-dialog/date-picker.model";
import { GraphData } from "src/app/models/dashboard.model";
import { HeaderService } from "src/app/components/header/header.service";
import { Subject } from "rxjs";
@Component({
  selector: "app-shipment-collection-graph",
  templateUrl: "./shipment-collection-graph.component.html",
  styleUrls: ["./shipment-collection-graph.component.scss"],
})
export class ShipmentCollectionGraphComponent implements OnInit, OnChanges, OnDestroy {
  @Input() graphStats;
  @Input() productName;
  @Input() graphData: GraphData;
  @Input() height;
  @Input() width;
  @Input() loading:boolean =false;
  @Input() showTitle: boolean;
  @Input() id;
  @Input() chartColors;
  @Input() labels;
  @Input() chartData;
  @Input() yAxisLabelType;
  @Input() tickInterval;
  @Input() type;
  @Input() isDecimal:Boolean = false;
  @Input() isProductDashBoard:boolean = false;
  link: string;
  chartLegendName:any[]=[];
  currentDateFilter: DatePickerModel;
  showHideChartData:any[] = [];
  private destroy$ = new Subject<void>();

  constructor( private headerService: HeaderService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.link = "/assets/images/sprite-icons.svg#" + this.productName + "_icon";
  }

  ngOnInit(): void { 
    this.chartData.forEach((el:any)=>{
      el.hide = false;
    })
    const today = new Date();
    this.currentDateFilter={
      to: today,
      from:new Date(today.getTime() - this.getDaysAgo(this.isProductDashBoard ? 30 : 90)),
      label: this.isProductDashBoard ? 'Last 30 Days' : 'Last 90 Days'
    }
  }

  getDaysAgo(amountOfDays: number): number {
    return amountOfDays * 24 * 60 * 60 * 1000;
  }

  onChange(item, i) {
    let index = this.chartData.findIndex((el) => el.name == item.name);
    if (index !== -1) {
      if (this.chartData[index].hide !== true) {
        this.chartData[index].hide = true;
      } else {
        this.chartData[index].hide = false;
      }
    }
    let idx = this.showHideChartData?.findIndex((res) => res == item.name);
    idx == -1 ? this.showHideChartData.push(this.chartData[i].name) : this.showHideChartData.splice(idx, 1)
    this.headerService.hideLine.next({showHideChartData:this.showHideChartData,chartId:this.id});
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
